module.exports = __webpack_public_path__ + "ee403d22c60149459479fbf8f85bd8c8.png";